/**
 * ZENTRALE PRODUKT-FAKTEN — die EINZIGE Quelle für Angebots-, Preis-, Vertrags- und Leistungszahlen.
 * Leistungszählung wird direkt aus den USP-Datenlisten berechnet, Preise aus calculator.js
 * (== backend/config/constants.py) → kein Drift zwischen React, Checkout, FAQ, SEO-Shell & JSON-LD.
 *
 * Regel: NIE „inklusive 37 Leistungen" schreiben (14 sind bedingt). Immer den ehrlichen Split
 * verwenden: „37 Leistungen insgesamt – 23 sofort, 14 freischaltbar".
 */
import {
  PRIVATE_INCLUDED_USPS,
  PRIVATE_UNLOCKED_USPS,
  PRIVATE_ASSISTANT_USPS,
} from '../data/privateUsps';
import { SILVER_CARD_PRICING, GOLD_CARD_PRICE } from '../lib/calculator';

export const BRAND_NAME = 'FuelX';
export const PRODUCT_NAME = 'FuelX Card';
export const CREDIT_NAME = 'FuelGood';
export const SITE_URL = 'https://fuelxcard.com';

// ── Leistungsmodell (aus den echten USP-Listen berechnet → kein Drift) ──
export const BENEFITS_EXPERT = PRIVATE_INCLUDED_USPS.length;        // Experten-Leistungen (ab Tag 1)
export const BENEFITS_ASSISTANT = PRIVATE_ASSISTANT_USPS.length;    // digitale Assistent-Services (ab Tag 1)
export const BENEFITS_INCLUDED = BENEFITS_EXPERT + BENEFITS_ASSISTANT; // 23 ab Tag 1
export const BENEFITS_UNLOCKABLE = PRIVATE_UNLOCKED_USPS.length;    // 14 über qualifizierende Hotelbuchungen
export const BENEFITS_TOTAL = BENEFITS_INCLUDED + BENEFITS_UNLOCKABLE; // 37 gesamt

// Einheitliche Formulierungen (überall wiederverwenden):
export const BENEFITS_SPLIT_SHORT = `${BENEFITS_TOTAL} Leistungen insgesamt – ${BENEFITS_INCLUDED} sofort, ${BENEFITS_UNLOCKABLE} freischaltbar`;
export const BENEFITS_SPLIT_LONG = `${BENEFITS_TOTAL} Leistungen für dein Auto: ${BENEFITS_INCLUDED} sofort nutzbar, ${BENEFITS_UNLOCKABLE} weitere über qualifizierende FuelX-Hotelbuchungen freischaltbar.`;
export const BENEFITS_INCLUDED_LABEL = `Das ist sofort enthalten: ${BENEFITS_INCLUDED} Leistungen`;
export const BENEFITS_UNLOCKABLE_LABEL = `Über FuelX Hotels freischaltbar: ${BENEFITS_UNLOCKABLE} Leistungen`;

// ── Preise (einzige Quelle: calculator.js == backend/config/constants.py) ──
const _priceForKm = (km) =>
  (SILVER_CARD_PRICING.find((t) => km <= t.max_km) || SILVER_CARD_PRICING[SILVER_CARD_PRICING.length - 1]).price;
const _de = (n) => `${Number(n).toFixed(2).replace('.', ',')} €`;

export const ENTRY_PRICE = SILVER_CARD_PRICING[0].price; // 99,90 €
export const PRICE_15000 = _priceForKm(15000);           // 139,90 €
export const GOLD_PRICE = GOLD_CARD_PRICE;               // 49,90 €
export const ENTRY_PRICE_LABEL = `ab ${_de(ENTRY_PRICE)}/Jahr`;
export const GOLD_PRICE_LABEL = `${_de(GOLD_PRICE)}/Fahrzeug/Jahr`;
export const priceForKm = _priceForKm;
export const priceLabelForKm = (km) => _de(_priceForKm(km));

// ── Vertragskonditionen ──
export const TERM_MONTHS = 12;
export const RENEWAL_LABEL = 'automatische jährliche Verlängerung';
export const CANCELLATION_DAYS = 30;   // zum Laufzeitende
export const WITHDRAWAL_DAYS = 14;     // gesetzliches Widerrufsrecht
export const TERMS_SENTENCE = `${TERM_MONTHS} Monate Laufzeit · ${RENEWAL_LABEL} · Kündigungsfrist ${CANCELLATION_DAYS} Tage zum Laufzeitende · ${WITHDRAWAL_DAYS} Tage Widerrufsrecht`;
export const billingNoteForPrice = (label) =>
  `Heute werden ${label} abgebucht. Die Mitgliedschaft verlängert sich jährlich. ${WITHDRAWAL_DAYS} Tage Widerrufsrecht. Kündigungsfrist: ${CANCELLATION_DAYS} Tage zum Laufzeitende.`;

// ── Ersparnis / FuelGood ──
export const SAVINGS_PER_LITER_EUR = 0.40;
export const SAVINGS_PER_LITER_LABEL = 'Ø 0,40 € pro Liter';
export const SAVINGS_DISCLAIMER = 'Die Ø-Ersparnis ist ein Richtwert bei aktiver Nutzung qualifizierender FuelX-Angebote. FuelX reduziert nicht unmittelbar den angezeigten Preis an der Zapfsäule.';
export const FUELGOOD_DISCLAIMER = 'FuelGood ist zweckgebunden und nicht als Bargeld auszahlbar.';

// ── Reichweite / Netzwerk ──
export const STATIONS_LABEL = '150.000+';
export const HOTELS_LABEL = 'rund 1,6 Mio. Unterkünfte';
export const HOTELS_SHORT = '1,6 Mio Hotels';
export const WORKSHOPS_LABEL = '2.400+';
export const CUSTOMERS_LABEL = '8.000+';

// ── Bewertungen (Fallback; live über /api/reviews/stats) ──
export const REVIEWS_AVG = 4.7;
export const REVIEWS_COUNT = 180;
